import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/buildhome/repo/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/local/target.css?{\"path\":\"node_modules/geist/dist/sans.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/geist-sans/Geist-Variable.woff2\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"GeistSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundaryClient","DOMInspector","AnalyticsTracker"] */ "/opt/buildhome/repo/src/utils/creatr.scripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalErrorHandler"] */ "/opt/buildhome/repo/src/utils/global-error-handler.tsx");
